import { render, staticRenderFns } from "./ManageStockTake.vue?vue&type=template&id=715ea4c9&"
import script from "./ManageStockTake.vue?vue&type=script&lang=js&"
export * from "./ManageStockTake.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports